import { NgTemplateOutlet, isPlatformServer } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { AssetDto, AssetVersionDto, GalleryDto } from '@nusign/picflow-backend-types';
import { DownloadSizeSelectionComponent } from '../../../gallery-shared/components/download-size-selection/download-size-selection.component';
import { IosDownloadContextComponent } from '../../../gallery-shared/components/ios-download-context/ios-download-context.component';
import { GalleryAccessLevel } from '../../../lib/access-level';
import { getAllowedDownloadSizes } from '../../../lib/convert-gallery-download-size';
import { IsIos } from '../../../lib/is-ios';
import { DownloadAssetService } from '../../../services/download-asset.service';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-asset-download-button',
  templateUrl: './asset-download-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContextMenuComponent,
    DownloadSizeSelectionComponent,
    IosDownloadContextComponent,
    TooltipDirective,
    TranslatePipe,
    NgTemplateOutlet,
  ],
})
export class AssetDownloadButtonComponent implements OnChanges {
  private check = inject(ChangeDetectorRef);
  private downloadAssetService = inject(DownloadAssetService);
  private platformId = inject(PLATFORM_ID);

  @Input() clientEl: HTMLElement;
  @Input() accessLevel: GalleryAccessLevel;
  @Input() asset: AssetDto;
  @Input() version: AssetVersionDto;
  @Input() gallery: GalleryDto;
  @Input() previewWidth: number;
  @Input() reportDownloads = true;

  iosDownloadMenu: boolean;
  singleDownloadOption: number;
  onlyOneSize: boolean;

  ngOnChanges(): void {
    if (isPlatformServer(this.platformId)) return;
    this.iosDownloadMenu = !!IsIos() && this.asset.type === 'image' && !!this.asset.version_data.data?.width;
    const { sizes, allowOriginalDownload } = getAllowedDownloadSizes(
      this.gallery.download_media_size,
      this.accessLevel,
      this.asset
    );

    const allowedSizesCount = sizes.filter(s => s.name !== 'original').length + (allowOriginalDownload ? 1 : 0);
    this.onlyOneSize = allowedSizesCount === 1;

    this.singleDownloadOption = this.onlyOneSize ? sizes[0]?.size : undefined;
    this.check.detectChanges();
  }

  download(size?: number) {
    this.downloadAssetService.downloadAssetVersion(
      this.version || this.asset.version_data,
      this.asset.type,
      this.gallery.id,
      this.asset.watermark_enabled,
      size,
      this.reportDownloads
    );
  }
}
